<template>
  <div class="em-chart-card">
    <div class="em-chart-card__header">
      <div class="em-chart-card__icon em-chart-card__icon--blue">
        <font-awesome-icon :icon="['fas', 'chart-bar']" />
      </div>
      <div>
        <h3 class="em-chart-card__title">Top Employers</h3>
        <p class="em-chart-card__subtitle">By number of students</p>
      </div>
    </div>

    <div v-if="hasData" class="em-chart-card__body">
      <apexchart
        type="bar"
        height="360"
        :options="chartOptions"
        :series="chartSeries"
        @dataPointSelection="onBarSelect"
      />
    </div>
    <div v-else class="em-chart-empty">
      <p class="em-chart-empty__text">No employer data available</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopEmployersChart',
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  emits: ['employer-clicked'],
  computed: {
    hasData: function () {
      return this.data && this.data.length > 0;
    },
    labels: function () {
      var self = this;
      return (this.data || []).map(function (item) {
        return self.shortLabel(item.name);
      });
    },
    fullNames: function () {
      return (this.data || []).map(function (item) {
        return item.name;
      });
    },
    chartSeries: function () {
      return [
        {
          name: 'Students',
          data: (this.data || []).map(function (item) {
            return item.count;
          }),
        },
      ];
    },
    chartOptions: function () {
      var fullNames = this.fullNames;
      return {
        chart: {
          type: 'bar',
          toolbar: { show: false },
          fontFamily: 'inherit',
        },
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 6,
            borderRadiusApplication: 'end',
            barHeight: '62%',
            distributed: true,
            dataLabels: {
              position: 'center',
            },
          },
        },
        colors: [
          '#1d4ed8',
          '#2563eb',
          '#3b82f6',
          '#0ea5e9',
          '#0284c7',
          '#0369a1',
          '#1e40af',
          '#334155',
          '#475569',
          '#64748b',
        ],
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '12px',
            fontWeight: 700,
            colors: ['#ffffff'],
          },
        },
        xaxis: {
          categories: this.labels,
          title: {
            text: 'Students',
            style: { fontSize: '12px', fontWeight: 600, color: '#64748b' },
          },
          labels: {
            style: { fontSize: '11px', colors: '#64748b' },
          },
        },
        yaxis: {
          labels: {
            style: { fontSize: '11px', colors: '#334155', fontWeight: 600 },
            maxWidth: 180,
          },
        },
        grid: {
          borderColor: '#e2e8f0',
          strokeDashArray: 4,
        },
        legend: { show: false },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + (val === 1 ? ' student' : ' students');
            },
          },
          x: {
            formatter: function (val, opts) {
              var idx = opts && opts.dataPointIndex != null ? opts.dataPointIndex : -1;
              if (idx >= 0 && fullNames[idx]) {
                return fullNames[idx];
              }
              return val;
            },
          },
        },
      };
    },
  },
  methods: {
    shortLabel: function (name) {
      var text = String(name || '');
      if (text.length <= 28) {
        return text;
      }
      return text.substring(0, 26) + '…';
    },
    onBarSelect: function (event, chartContext, config) {
      var idx = config && config.dataPointIndex != null ? config.dataPointIndex : -1;
      if (idx < 0 || !this.fullNames[idx]) {
        return;
      }
      this.$emit('employer-clicked', this.fullNames[idx]);
    },
  },
};
</script>

<style scoped>
.em-chart-card {
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #e5e7eb;
  border-radius: 1rem;
  padding: 1.25rem;
  height: 100%;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}
.em-chart-card__header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}
.em-chart-card__icon {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.em-chart-card__icon--blue {
  background: #dbeafe;
  color: #1d4ed8;
}
.em-chart-card__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
}
.em-chart-card__subtitle {
  margin: 0.125rem 0 0;
  font-size: 0.75rem;
  color: #64748b;
}
.em-chart-card__body {
  min-height: 360px;
}
.em-chart-empty {
  min-height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #cbd5e1;
  border-radius: 0.75rem;
  background: #f8fafc;
}
.em-chart-empty__text {
  margin: 0;
  color: #64748b;
  font-size: 0.875rem;
}
</style>
